import React, { useEffect, useRef, useState } from "react";
import styles from './hero.module.css';
export default function Hero({}) {
    const [title, setTitle] = useState('Kwik Fill Giveaway!');
    const [body, setBody] = useState('');
    const [button_title, setButtonTitle] = useState('Learn More');

    const videoRef= useRef<HTMLVideoElement>();
    const [playbackRate, setPlaybackRate] = useState(0.75);

    useEffect(() => {
        fetchHeroTitle();
        
        if (videoRef && videoRef.current && videoRef.current.playbackRate) {
            videoRef.current.playbackRate = playbackRate;
        }
    }, [playbackRate]);
    
    const fetchHeroTitle = () => {
        fetch('https://kwik.burcs.workers.dev/query', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer 1b08552890094f86e6038a16d3b4d51a30aec0468565536e55c28e380f7488b2',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sql: `
                    SELECT
                    id,
                    json_extract(block_data, '$.blocks[1].data.text') AS paragraph_text
                    FROM content
                    WHERE id = 2 AND json_extract(block_data, '$.blocks[1].id') = 'uHLc93-50V'
                `
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data && data.result && data.result.length > 0) {
                setTitle(data.result[0].paragraph_text || "Kwik Fill Giveaway!");
            }
        })
        .catch(error => {
            console.error('Error fetching hero title:', error);
        });
    };

    const setPlayBack = (e: any) => {
        setPlaybackRate(e.target.value);
    };

    return (
        <div className={styles.container}>
            <div className={styles.container_inner}>
                <div className={styles.video_wrapper}>
                    <video ref={videoRef} className={styles.video} width="320" height="240" autoPlay loop muted>
                        <source src={`https://operation-give-thanks.s3.amazonaws.com/website/default_video.mp4`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className={styles.content_gradient_overlay}></div>


                <div className={styles.content_container} style={{ textAlign: 'center' }}>
                    <h1 className={styles.title}>{title}</h1>
                    <div className={styles.body}>{body}</div>
                    <div onClick={() => { 
                        window.location.href = '/win';
                     }} className={styles.button}>{button_title}</div>
                </div>

            </div>

            
        </div>
    );
}
